import React from "react";
import ProceduresManualContext from './ProceduresManualContext';
import styled from 'styled-components';
import { Button, Divider } from '@material-ui/core';
import ViewManualIcon from '@material-ui/icons/OpenInNewOutlined';
import PublishManualIcon from '@material-ui/icons/PostAddOutlined';


const BottomButtonsContainer = styled.div`

    display:grid;
    width:100%;
    padding-top:20px;
    padding-left:20px;
    padding-right:20px;
    grid-template-columns: minmax(auto,250px) minmax(auto,250px) 1fr  minmax(auto,80px) 20px  minmax(auto,80px)
`;

const IconContainer = styled.div`
padding-right:10px;
display:flex;
align-items:center;
`;

const ButtonContainer = styled.div`
`;

const FooterContainer = styled.div`
  height: ${props => props.height ? props.height : '68px'}
`

const ProceduresManualFooter = (props) => {

  const context = React.useContext(ProceduresManualContext);
  const loading = !context.procedureManual.header;
  const { creatingProcedureManual, procedureManualShouldUpdate, header, actionGroupForDisplayedProcedureManual = {} } = context.procedureManual;

  const { readOnly } = actionGroupForDisplayedProcedureManual;

  return (
    <FooterContainer height={props.height}>
      <Divider />
      <BottomButtonsContainer>

        <ButtonContainer>
          <Button
            fullWidth
            disabled={creatingProcedureManual || !header.hasPdf}
            color="primary"
            href={`/api/procedures/downloadProcedureManual/${context.procedureManual.header.functionId}/${context.procedureManual.header.projectId}`}
          >
            <IconContainer>
              <ViewManualIcon />
            </IconContainer>
            View Procedures Manual
          </Button>
        </ButtonContainer>
        <ButtonContainer>
          {(header.canUpdateProcedureManual && !readOnly) && (
            <Button
              disabled={
                !procedureManualShouldUpdate ||
                creatingProcedureManual ||
                !context.sdnFormValue ||
                !context.sdnRevFormValue
              }
              color="primary"
              fullWidth
              onClick={() => {
                context.createProcedureManual({
                  functionId: context.procedureManual.header.functionId,
                  projectId: context.procedureManual.header.projectId,
                  sdn: context.sdnFormValue,
                  rev: context.sdnRevFormValue,
                  comment: context.sdnCommentFormValue,
                });
              }}
            >
              <IconContainer>
                <PublishManualIcon />
              </IconContainer>
              Publish New Version
            </Button>
          )}
        </ButtonContainer>
        {!readOnly &&
          <>
            <div />
            <ButtonContainer>
              <Button
                fullWidth
                variant="outlined"
                disabled={creatingProcedureManual}
                color="primary"
                onClick={() => {
                  context.hideProcedureManual();
                }}
              >
                Cancel
              </Button>
            </ButtonContainer>
            <div />
            <ButtonContainer>
              <Button
                variant="contained"
                disabled={
                  (context.sdnFormValue === context.procedureManual.header.sdn &&
                    context.sdnRevFormValue === context.procedureManual.header.rev) ||
                  (context.sdnFormValue === null || context.sdnRevFormValue === null) ||
                  creatingProcedureManual
                }
                color="primary"
                fullWidth
                onClick={() => {
                  context.updateSDN({
                    functionId: context.procedureManual.header.functionId,
                    projectId: context.procedureManual.header.projectId,
                    sdn: context.sdnFormValue,
                    rev: context.sdnRevFormValue,
                    comment: context.sdnCommentFormValue,
                  });
                  context.hideProcedureManual();
                }}
              >
                Save
              </Button>
            </ButtonContainer>
          </>
        }
      </BottomButtonsContainer>
    </FooterContainer>
  );
};

export default ProceduresManualFooter;